import { useManualBalanceHistory } from './useManualBalanceHistory';

export function ManualBalancePanel({ accountId }: { accountId: string }) {
  const history = useManualBalanceHistory(accountId);

  if (history.kind === 'unavailable') {
    return (
      <section data-testid="manual-balance-panel" aria-labelledby="manual-balance-panel-title">
        <h2 id="manual-balance-panel-title" className="sr-only">
          Manual balance history
        </h2>
        <p role="status" className="rounded-lg border border-border bg-card p-4 text-sm text-muted-foreground">
          Balance updates and history aren’t available yet.
        </p>
      </section>
    );
  }

  return null;
}

export default ManualBalancePanel;
